import React, { useState } from 'react';
import ScheduleDemoForm from './ScheduleDemoForm';

const ScheduleDemo = () => {
    const [scheduleDemo, setScheduleDemo] = useState(false);

    return (
        <div id="demo">
            <button className="btn_demo"  onClick={() => {setScheduleDemo(!scheduleDemo)}} style={{"color":"#6ca438"}}>
                Schedule a Demo
            </button>
            
            <div id="demo_container" className={scheduleDemo ? "show" : "hide"}>
                <button 
                    id="demo_form_close"
                    onClick={() => {setScheduleDemo(!scheduleDemo)}}
                > X </button>
                <div id="demo_form_container" ></div>
                <ScheduleDemoForm />
            </div>
        </div>
    );
};

export default ScheduleDemo;